import React from 'react';
import { PricingDetail } from './components/PricingDetail';
export function App() {
  return <div className="min-h-screen bg-slate-100 p-8 flex justify-center items-start" data-id="element-0">
      <PricingDetail data-id="element-1" />
    </div>;
}